import React, { memo, useMemo } from 'react'
import clsx from 'clsx'
import Image from 'components/shared/Image'
import Button from '@mui/material/Button'
import Link from '@mui/material/Link'
import CloseIcon from '@mui/icons-material/Close'
import { toggleValueFromString } from 'utils/universal'
import { useIntl } from 'react-intl'
import { parseFiltersToUrl } from 'filters'
import sx from './styles'

const VehicleTypeItem = ({
  item, value, onChange, showCloseButton,
}) => {
  const { formatMessage: f } = useIntl()
  const basePath = f({ id: 'ROUTE_SEARCH' })

  const handleButtonClick = (event, current) => {
    event.preventDefault()
    const newMakeValue = toggleValueFromString(value, current.name)
    onChange({ body: newMakeValue })
  }

  const subfolder = useMemo(() => (value.includes(item.name) ? 'OnHold' : 'OnHold'), [value, item])

  return (
    <Link
      href={`${basePath}${(parseFiltersToUrl({ body: item.name })).toLowerCase()}`}
    >
      <Button
        variant={value.includes(item.name) ? 'special' : 'secondary'}
        sx={sx.button}
        title={`Autos seminuevos ${item.text}`}
        startIcon={(
          <Image
            src={`/img/vehicleTypes/${subfolder}/${item.icon}.svg`}
            alt={`Autos seminuevos ${item.text}`}
            title={`Autos seminuevos ${item.text}`}
            width={38}
            height={15}
            objectFit="cover"
          />
        )}
        className={clsx({
          selected: value.includes(item.name),
        })}
        size="small"
        onClick={(e) => handleButtonClick(e, item)}
        endIcon={showCloseButton ? <CloseIcon /> : <div style={{ width: '18px' }} />}
      >
        {item.text}
      </Button>
    </Link>

  )
}

export default memo(VehicleTypeItem)
